import { render, staticRenderFns } from "./pres.vue?vue&type=template&id=62a7f74b&scoped=true&"
import script from "./pres.vue?vue&type=script&lang=ts&"
export * from "./pres.vue?vue&type=script&lang=ts&"
import style0 from "./pres.vue?vue&type=style&index=0&id=62a7f74b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a7f74b",
  null
  
)

export default component.exports